<template>
  <div>
    <el-dialog width="50%" close="closeSelected" :visible.sync="dialogVisible">
      <el-card class="chat-card" shadow="never">
        <div slot="header" class="card_header">
          <span>选择会话</span>
        </div>
        <div>
          <el-tree :data="source" ref="tree" node-key="ID" :props="{ label: 'NAME'}">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span @dblclick="selectGroup">
                <i class="el-icon-chat-square"></i>
                {{ node.label }}
              </span>
            </span>
          </el-tree>
          <iframe style="display:none;" :src="imSrc"></iframe>
        </div>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createNewSession">创建新会话</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <SelectTaskUser ref="selectTaskUser" :taskId="taskId"></SelectTaskUser>
  </div>
</template>

<script>
import { GetGroupByTaskID, GetTaskMemeber } from "@/api/modules/basicData/task";
import SelectTaskUser from "./SelectTaskUser.vue";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  components: {
    SelectTaskUser
  },

  data() {
    return {
      dialogVisible: false,
      source: [],
      taskId: "",
      imSrc: ""
    };
  },
  methods: {
    initialSource(val) {
      this.imSrc = "";
      this.taskId = val;
      GetGroupByTaskID(val).then(result => {
        if (!result || result.length === 0) this.createNewSession();
        else {
          this.source = result;
          this.dialogVisible = true;
        }
      });
    },
    closeSelected() {
      this.$refs.tree.setCheckedKeys([]);
    },
    //选择会话
    selectGroup() {
      let row = this.$refs.tree.getCurrentNode();
      if (row) {
        //开启会话 row.ID 群组ID
        let url = `RedCoral://IM/?usercode=${cookieUser.account}&taskId=${this.taskId}&sessionId=${row.ID}&chatType=2`;
        window.protocolCheck(url, () => {
          this.$message.warning("协议未注册");
        });
        this.imSrc = url;
        this.dialogVisible = false;
      }
    },
    //创建新回话
    createNewSession() {
      // this.$nextTick(() => {
      //   console.log("createNewSession");
      //   this.dialogVisible = true;
      //    this.$refs.selectTaskUser.dialogVisible = true;
      // });
      this.dialogVisible = false;
      this.$refs.selectTaskUser.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>